import { render, staticRenderFns } from "./ResultContracts.vue?vue&type=template&id=50d056a2"
import script from "./ResultContracts.vue?vue&type=script&lang=js"
export * from "./ResultContracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50d056a2')) {
      api.createRecord('50d056a2', component.options)
    } else {
      api.reload('50d056a2', component.options)
    }
    module.hot.accept("./ResultContracts.vue?vue&type=template&id=50d056a2", function () {
      api.rerender('50d056a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/management/contract/ResultContracts.vue"
export default component.exports